{
	"hero": {
		"welcome": "Welcome back,",
		"daysToGames_one": "{{count}} day to the Games",
		"daysToGames_other": "{{count}} days to the Games",
		"gamesToday": "The Games open today",
		"welcomeNoc": "Welcome, {{noc}}",
		"hostOfficial": "MASOC Official",
		"road": "Your sectors",
		"roadHere": "{{sector}} (you are here)",
		"roadLocked": "{{sector}} (not open yet)"
	},
	"filters": {
		"toggle": "Filter dashboard",
		"games": "Games",
		"allGames": "All games",
		"organisation": "Organisation",
		"allOrganisations": "All organisations",
		"mainFunction": "Main function",
		"allMainFunctions": "All main functions",
		"subFunction": "Sub function",
		"allSubFunctions": "All sub functions",
		"status": "Status",
		"allStatuses": "All statuses",
		"clear": "Clear filters"
	},
	"kpi": {
		"total": "Total records",
		"totalSub_one": "Across {{count}} organisation",
		"totalSub_other": "Across {{count}} organisations",
		"approved": "Approved AC cards",
		"approvedSub": "{{percent}}% of all records",
		"review": "Waiting for review",
		"reviewSub": "{{submitted}} submitted · {{pending}} pending",
		"back": "Returned or rejected",
		"backSub": "{{returned}} returned · {{rejected}} rejected"
	},
	"status": {
		"title": "Status summary",
		"subtitle": "Every record in view",
		"progress": "Approval progress",
		"progressAria": "Approval progress: {{approved}} of {{active}} ({{percent}}%)"
	},
	"notCounted": "Rejected and withdrawn not counted",
	"empty": "No records yet.",
	"orgs": {
		"title": "Records by organisation",
		"showAll": "Show all {{count}}",
		"showFewer": "Show fewer"
	},
	"categories": {
		"title": "Records by category"
	},
	"attention": {
		"title": "Needs attention",
		"review": "Waiting for review",
		"reviewHint": "Submitted by organisations",
		"returned": "Returned to you",
		"returnedHint": "Fix and resubmit",
		"noPhoto": "No photo",
		"noPhotoHint": "Card cannot print",
		"drafts": "Drafts",
		"draftsHint": "Saved, not submitted"
	},
	"quick": {
		"title": "Quick actions",
		"register": "Register new record",
		"shortlist": "Shortlist entries",
		"records": "View records",
		"drafts": "Finish drafts"
	},
	"error": {
		"title": "The numbers could not be loaded",
		"retry": "Try again"
	},
	"footer": {
		"logoAlt": "SEA Games Malaysia 2027",
		"slogan": "Raikan perpaduan.",
		"sloganTranslated": "Celebrating unity."
	},
	"contingent": {
		"intro": "Your whole delegation on one page. Pick a tile to list exactly those people below.",
		"openPage": "Open the page →",
		"tickets": "Open room tickets",
		"sections": {
			"accreditation": "Accreditation & cards",
			"travel": "Arrivals & departures",
			"transfers": "Transfers",
			"rooms": "Accommodation & meals",
			"readiness": "Readiness"
		},
		"filters": {
			"all": "Everyone registered",
			"approved": "Approved",
			"review": "Waiting for review",
			"returned": "Returned to you",
			"no_photo": "No photo",
			"to_print": "Waiting to print",
			"card_active": "Card active",
			"arriving_today": "Arriving today",
			"arriving_tomorrow": "Arriving tomorrow",
			"departing_today": "Departing today",
			"delayed": "Delayed or cancelled",
			"no_arrival": "Approved, no arrival",
			"no_departure": "Approved, no departure",
			"needs_transfer": "Needs a transfer",
			"transfer_booked": "Transfer with driver",
			"in_house": "In house",
			"no_bed": "Approved, no bed",
			"no_hall": "No dining hall",
			"not_ready": "Not ready to arrive"
		},
		"readiness": {
			"arrival": "Arrival entered",
			"departure": "Departure entered",
			"bed": "Bed assigned",
			"of_one": "of {{n}} approved person",
			"of_other": "of {{n}} approved people",
			"percent": "{{percent}}%",
			"showMissing": "List the people still missing it"
		},
		"picker": {
			"label": "NOC",
			"placeholder": "Choose a NOC",
			"prompt": "Choose a NOC above to see its delegation."
		},
		"transfer": {
			"none": "None booked",
			"booked": "No driver yet",
			"ready": "Driver confirmed",
			"recheck": "Re-check driver",
			"notNeeded": "Not needed"
		},
		"flight": {
			"DELAYED": "Delayed",
			"CANCELLED": "Cancelled",
			"DEPARTED": "Departed",
			"LANDED": "Landed"
		},
		"table": {
			"name": "Person",
			"card": "Card",
			"arrival": "Arrival",
			"departure": "Departure",
			"transfer": "Transfer",
			"bed": "Bed",
			"hall": "Dining hall",
			"ready": "Ready",
			"none": "—",
			"inHouse": "In house",
			"notCheckedIn": "Not checked in",
			"notReady": "Not ready",
			"ok": "Ready",
			"showAll": "Show everyone",
			"search": "Search by name",
			"emptyTitle": "Nobody here",
			"emptyHint": "No one in this delegation matches this tile.",
			"loadMore": "Load more ({{shown}} of {{total}})"
		},
		"competitionIntro": "Your delegation's competition: where and when it competes, its medals and its records.",
		"loadMore": "Show more ({{shown}} of {{total}})",
		"showMore": "Show more ({{shown}} shown)",
		"tabs": {
			"label": "Select a section",
			"readiness": "Readiness",
			"schedule": "Schedule",
			"medals": "Medals",
			"records": "Records",
			"venues": "Venues"
		},
		"schedule": {
			"title": "Schedule",
			"whenLabel": "Show",
			"when": {
				"all": "All",
				"upcoming": "Upcoming",
				"live": "Live",
				"finished": "Finished"
			},
			"medalOnly": "Medal events only",
			"daysLabel": "Days",
			"allDays": "All days",
			"dayChip_one": "{{date}}: {{n}} meet",
			"dayChip_other": "{{date}}: {{n}} meets",
			"unscheduled_one": "{{n}} meet has no time yet and is not listed.",
			"unscheduled_other": "{{n}} meets have no time yet and are not listed.",
			"cols": {
				"time": "Time",
				"event": "Event",
				"venue": "Venue",
				"ours": "Our entries",
				"status": "Status"
			},
			"medalEvent": "Medal event",
			"noVenue": "No venue yet",
			"field_one": "{{n}} in the field",
			"field_other": "{{n}} in the field",
			"rank": "Rank {{rank}}",
			"status": {
				"NONE": "Scheduled",
				"START_LIST": "Start list",
				"LIVE": "Live",
				"UNOFFICIAL": "Unofficial result",
				"OFFICIAL": "Official result",
				"TENTATIVE": "Tentative",
				"SCHEDULED": "Scheduled",
				"DELAYED": "Delayed",
				"INTERRUPTED": "Interrupted",
				"POSTPONED": "Postponed",
				"CANCELLED": "Cancelled"
			},
			"emptyTitle": "No meets",
			"emptyHint": "Nothing matches these filters for this delegation.",
			"count_one": "{{n}} meet",
			"count_other": "{{n}} meets"
		},
		"medal": {
			"GOLD": "Gold",
			"SILVER": "Silver",
			"BRONZE": "Bronze"
		},
		"medals": {
			"summaryLabel": "Medal summary",
			"rank": "Medal table position",
			"rankOf_one": "{{rank}} of {{n}}",
			"rankOf_other": "{{rank}} of {{n}}",
			"noRank": "No medals yet",
			"total": "Total",
			"oursEmpty": "No medals yet",
			"oursEmptyHint": "A medal appears here as soon as the medal desk awards it.",
			"medallistsTitle": "Medallists",
			"allMedallists": "All",
			"multi": "2 or more medals",
			"medallistsEmpty": "No medallists yet",
			"team": "Team",
			"standingsTitle": "Medal standings",
			"standingsHint": "Every NOC of the games. Your delegation is highlighted.",
			"cols": {
				"rank": "Rank",
				"noc": "NOC",
				"name": "Name",
				"sport": "Sport"
			},
			"sub": {
				"tally": "Medal tally",
				"chances": "Medal chances",
				"medallists": "Medallists"
			},
			"ourTally": "Our medal tally",
			"ourTallyHint": "By sport. Open a sport for its events and winners.",
			"awardedOn": "Awarded {{date}}",
			"medallistsHint": "Open a row to see each medal.",
			"medallistsEmptyHint": "Your medallists appear here as soon as a medal is awarded."
		},
		"records": {
			"title": "Records set",
			"cols": {
				"record": "Record",
				"who": "Athlete or team",
				"event": "Event",
				"result": "Result",
				"when": "Date"
			},
			"types": {
				"WR": "World record",
				"OR": "Olympic record",
				"PR": "Paralympic record",
				"AR": "Asian record",
				"GR": "Games record",
				"NR": "National record"
			},
			"emptyTitle": "No records yet",
			"emptyHint": "A record appears here when one of our results is marked as a record."
		},
		"venues": {
			"cols": {
				"meets": "Our meets"
			},
			"finishedOf": "{{finished}} of {{meets}} finished",
			"none": "None to come",
			"emptyTitle": "No venues yet",
			"emptyHint": "A venue appears when one of this delegation's meets is given one.",
			"nextAt": "Next: {{when}}"
		},
		"section": {
			"schedule": {
				"title": "Schedule & results",
				"hint": "Every meet of your delegation, day by day. Open a meet for its start list and results."
			},
			"medals": {
				"title": "Medals",
				"tally": "Where you stand in the medal table, and every medal your delegation has won.",
				"chances": "Meets still to come that can bring your delegation a medal.",
				"medallists": "Your athletes who won medals, most golds first."
			},
			"records": {
				"title": "Record breakers",
				"hint": "Results of your delegation marked as a record."
			},
			"venues": {
				"title": "Venues",
				"hint": "Where your delegation competes, and when it is next there."
			}
		},
		"chances": {
			"title": "Medal chances",
			"all": "All chances",
			"athletes": "Athletes in contention",
			"vs": "vs",
			"emptyTitle": "No medal chances right now",
			"emptyHint": "Medal meets with your entries in them appear here until they finish.",
			"kind": {
				"gold_match": "Gold match",
				"bronze_match": "Bronze match",
				"medal_final": "Medal final",
				"semifinal": "Semifinal"
			},
			"live_one": "{{n}} live",
			"live_other": "{{n}} live"
		},
		"match": {
			"loading": "Loading the meet…",
			"medal": "Medal",
			"noTime": "Time to be announced",
			"start": "Start list",
			"results": "Results",
			"noResults": "Results not available yet",
			"noResultsHint": "They appear here as soon as the meet starts.",
			"noStartList": "Start list not available yet",
			"tba": "To be decided",
			"side": "Side",
			"period": "P{{n}}",
			"total": "Total",
			"rank": "Rank",
			"order": "Order",
			"entrant": "Athlete or team",
			"result": "Result",
			"lane": "Lane · bib"
		}
	},
	"sector": {
		"open": "Open",
		"cards": {
			"title": "Accreditation cards",
			"sub": "Approved cards, from printing to activation",
			"total": "Approved cards"
		},
		"entries": {
			"intro": "Plan your delegation: tell the host which sports you will enter (Expression of interest), then how many athletes per event (Entry by number).",
			"noRights": "Sport entries are made by your NOC's entries officer. Ask your administrator if you should have access.",
			"none": "No organisation to show yet.",
			"sports": "Sports",
			"athletes": "Athletes",
			"menWomen": "{{men}} men · {{women}} women",
			"officials": "Officials",
			"medals": "Medals expected",
			"medalSplit": "{{gold}} gold · {{silver}} silver · {{bronze}} bronze",
			"events": "Events entered",
			"entries": "Entries",
			"impliedAthletes": "Athletes implied",
			"next": {
				"eoi": "Next: your Expression of interest",
				"eoiHint": "Choose your sports and give your estimates, then submit it as final.",
				"eoiGo": "Open Expression of interest",
				"ebn": "Next: your Entry by number",
				"ebnHint": "Your expression of interest is in. Now enter how many athletes or teams per event.",
				"ebnGo": "Open Entry by number",
				"done": "Both phases are submitted",
				"doneHint": "Well done. The names of your athletes go in the Shortlist (Sector 2).",
				"doneGo": "Open Shortlist"
			}
		},
		"logistics": {
			"intro": "Today at the Games: who lands and leaves, the transfers, the beds and the meals.",
			"none": "Nothing in this sector is open to your login yet. Ask your administrator if you should have access.",
			"today": "Today",
			"tonight": "Tonight",
			"travel": {
				"title": "Arrivals & departures",
				"arriving": "Arriving today",
				"landed": "Landed: {{n}}",
				"tomorrow": "Arriving tomorrow",
				"departing": "Departing today",
				"departed": "Departed: {{n}}",
				"delayed": "Delayed",
				"cancelled": "Cancelled: {{n}}",
				"noArrival": "No arrival yet",
				"noArrivalHint": "Approved, no arrival entered"
			},
			"transport": {
				"title": "Transfers",
				"trips": "Trips today",
				"next24": "Next 24 hours",
				"onRoad": "On the road",
				"passengers": "Your passengers today",
				"unassigned": "Unassigned, next 24 h",
				"overdue": "Overdue: {{n}}",
				"drivers": "Drivers: {{n}}",
				"waiting": "Waiting for a transfer",
				"waitingHint": "People, today",
				"vehicles": "Vehicles",
				"maintenance": "In maintenance: {{n}}"
			},
			"rooms": {
				"title": "Accommodation",
				"occupancy": "Beds in use",
				"ofBeds": "{{used}} of {{beds}}",
				"inHouse": "In house",
				"arriving": "Arriving today",
				"overdue": "Late check-ins: {{n}}",
				"departing": "Departing today",
				"withoutBed": "Without a bed",
				"withoutBedHint": "Approved people",
				"nocSub": "Your delegation",
				"nocNone": "No rooming for your delegation yet.",
				"withBedLine": "People with a bed",
				"ofPeople": "{{n}} of {{total}}",
				"reserved": "Beds reserved",
				"checkedIn": "Checked in"
			},
			"meals": {
				"title": "Food & beverages",
				"served": "Served: {{n}}",
				"pending": "Orders to confirm",
				"pendingHint": "Takeaway, all dates",
				"halls": "Your dining halls",
				"confirmed": "Confirmed orders"
			}
		}
	},
	"overall": {
		"ofTotal": "{{n}} of {{total}}",
		"entries": {
			"sub": "Expressions of interest and entries by number"
		},
		"accreditation": {
			"sub": "Records and accreditation cards",
			"approved": "Approved",
			"drafts": "Drafts",
			"active": "Cards active"
		},
		"logistics": {
			"sub": "Today's travel, transfers and beds"
		},
		"noc": {
			"intro": "Your delegation in every sector at a glance. Open a sector for its own dashboard.",
			"eoiSports": "Sports in your EOI",
			"ebnEntries": "Entries by number",
			"locked": "This sector opens when your NOC reaches Sector {{n}}. The organising committee will let you know.",
			"contingentSub": "Your delegation's readiness"
		}
	},
	"admin": {
		"intro": "The Games at a glance: records, athletes, the sport programme and entries, for every organisation.",
		"ofNocs": "of {{n}} NOCs",
		"pctOfRecords": "{{pct}} of records",
		"col": {
			"organisation": "Organisation",
			"noc": "NOC",
			"sport": "Sport",
			"total": "Total"
		},
		"records": {
			"title": "Records by organisation",
			"sub": "MASOC's and every NOC's records, by where they are in the workflow.",
			"total": "Records",
			"totalHint": "Rejected and withdrawn left out",
			"draft": "Draft",
			"submitted": "Submitted",
			"returned": "Returned",
			"approved": "Approved",
			"chartTitle": "Records per organisation",
			"chartDesc": "The longest bar is the organisation with the most records. Point at a bar for its numbers; select it to open its records.",
			"host": "MASOC and host organisations",
			"nocs": "NOCs",
			"approvedShort": "{{pct}} approved",
			"rowLabel": "{{name}}: {{total}} records — {{draft}} draft, {{submitted}} submitted, {{returned}} returned, {{approved}} approved",
			"empty": "No records yet."
		},
		"athletes": {
			"title": "Longlist and shortlist",
			"sub": "Approved athletes each NOC registered (the longlist), and how many it has shortlisted for an event.",
			"longlist": "Longlist",
			"longlistHint": "Approved athletes",
			"shortlisted": "Shortlisted",
			"ofLonglist": "{{pct}} of the longlist",
			"notStarted": "NOCs not started",
			"chartTitle": "Athletes per NOC",
			"chartDesc": "The light bar is the longlist; the dark bar inside it, the athletes already shortlisted.",
			"value": "{{short}} / {{long}}",
			"primary": "Primary places",
			"reserve": "Reserve places",
			"rowLabel": "{{name}}: {{short}} of {{long}} athletes shortlisted",
			"empty": "No athletes registered yet."
		},
		"sports": {
			"title": "Sports and events",
			"sub": "The programme of the Games: active sports, disciplines and events.",
			"sports": "Sports",
			"disciplines": "Disciplines",
			"events": "Events",
			"inactive": "+{{n}} inactive",
			"chartTitle": "Events per sport",
			"chartDesc": "Active events in each sport, most first.",
			"showAll": "Show all {{n}} sports",
			"showLess": "Show fewer",
			"rowLabel": "{{name}}: {{n}} events",
			"empty": "No sports yet."
		},
		"entries": {
			"title": "EOI and EBN submissions",
			"sub": "Which NOCs have submitted their Expression of Interest and Entry by Number, and how many have not yet.",
			"eoi": "Expression of Interest (EOI)",
			"ebn": "Entry by Number (EBN)",
			"submitted": "Submitted",
			"inProgress": "In progress",
			"notStarted": "Not started",
			"nocsOf": "{{n}} of {{total}} NOCs submitted",
			"notYetPct": "{{pct}} not submitted yet",
			"gaugeLabel": "{{label}}: {{n}} of {{total}} NOCs submitted ({{pct}})",
			"tableTitle": "Each NOC",
			"tableDesc": "Submitted first, then in progress, then not started.",
			"empty": "No NOCs yet."
		}
	}
}
